<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>
    </div>

    <n-button v-if="edit.records && !checkIfSignIsExist(user.id, 'records')" @click="$var('acceptRec', true)">Подписать</n-button>
    <n-button v-if="edit.records && !checkIfSignIsExist(user.id, 'mid.records')" @click="$var('acceptRecMid', true)">Подписать</n-button>
    <n-button v-if="edit.records && !checkIfSignIsExist(user.id, 'end.records')" @click="$var('acceptRecEnd', true)">Подписать</n-button>
    <n-button v-if="edit.master && !checkIfSignIsExist(user.id, 'master')" @click="$var('acceptMas', true)">Подписать</n-button>
    <n-button v-if="edit.master && !checkIfSignIsExist(user.id, 'end.master')" @click="$var('acceptMasEnd', true)">Подписать</n-button>
    <br />
    <n-items>
      <n-input title="Сквозной порядковый номер" v-bind="$form.input('number')" :text="!edit.records" />
      <n-input title="Дата сварки, температура воздуха, °С" v-bind="$form.input('weldingDate')" :text="!edit.records" />
      <n-input title="Диаметр и толщина стенки трубы, мм" v-bind="$form.input('wallDiameter')" :text="!edit.records" />
      <n-input title="ГОСТ или ТУ, марка стали, завод-поставщик труб" v-bind="$form.input('gost')" :text="!edit.records" />
      <n-input title="Температура подогрева (просушки стыка), °С" v-bind="$form.input('tempHeating')" :text="!edit.records" />
      <n-input title="Наименование и № свариваемых элементов трубопровода" v-bind="$form.input('title')" :text="!edit.records" />
      <n-input title="Заводские номера труб" v-bind="$form.input('pipeNumber')" :text="!edit.records" />
      <n-input title="Привязка стыка (для неповоротной сварки): километр" v-bind="$form.input('weldingKilometer')" :text="!edit.records" />
      <n-input title="Привязка стыка (для неповоротной сварки): пикет" v-bind="$form.input('weldingPiket')" :text="!edit.records" />
      <n-input title="Способ сварки и положение при сварке" v-bind="$form.input('weldingWay')" :text="!edit.records" />
      <n-input title="Марка сварочных материалов" v-bind="$form.input('weldingMaterialMark')" :text="!edit.records" />
      <n-input title="Фамилия, инициалы бригадира (звеньевого) и номер схемы расположения сварщиков" v-bind="$form.input('foreman')" :text="!edit.records" />
      <n-input title="Номер шифра бригады или сварщика" v-bind="$form.input('cipherNumber')" :text="!edit.records" />
      <n-input title="Приемка стыка: по результатам контроля физическими методами или механическим испытаниям (заключение о годности стыка, номер, дата заключения)" v-bind="$form.input('physicMethods')" :text="!edit.records" />
      <n-input title="Сведения о проведении ремонта или удалении стыка: отремонтирован, удален, дата" v-bind="$form.input('fix')" :text="!edit.records" />
      <n-input title="Приемка стыка после ремонта: по результатам контроля физическими методами (заключение о годности, номер и дата заключения)" v-bind="$form.input('result')" :text="!edit.records" />
      <n-input title="Примечание" v-bind="$form.input('remark')" :text="!edit.records" />
    </n-items>
    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save()">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>

    <c-modal-journal-do-sign v-if="$var('acceptRec')" @close="$var('acceptRec', false)" @submit="(s) => accept('records', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptRecMid')" @close="$var('acceptRecMid', false)" @submit="(s) => accept('mid.records', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptRecEnd')" @close="$var('acceptRecEnd', false)" @submit="(s) => accept('end.records', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptMas')" @close="$var('acceptMas', false)" @submit="(s) => accept('master', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptMasEnd')" @close="$var('acceptMasEnd', false)" @submit="(s) => accept('end.master', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_records', this.project.id),
        master: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_master', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.spec63.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec63.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkIfSignIsExist(userId, signName) {
      let isExist = false
      if (this.record) {
        if (this.record.signs) {
          $n.each(this.record.signs, (el) => {
            if (el.authorId !== null || el.isApproved) {
              if (el.name === signName && el.authorId === userId && el.isApproved) {
                isExist = true
              }
            }
          })
        }
      }
      return isExist
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
